// Libs
import React, { useEffect, useState } from 'react';
import { ReactElement } from 'react';
// App
import { ToggleButton, ToggleButtonGroup } from 'ui-components';
import { TIME_PERIOD } from './filters.constants';
import { TIME_PERIOD_FILTERS } from './time-period-filters.constants';
import { TimePeriodFiltersProps } from './time-period-filters.interfaces';

const TimePeriodFilters = (props: TimePeriodFiltersProps): ReactElement => {
  const { className, value, periods = TIME_PERIOD_FILTERS, onChange } = props;
  const defaultValue = TIME_PERIOD.MONTH;
  const [selectedFilter, setSelectedFilter] = useState(value || defaultValue);

  /**
   * Applies changes in local state when provided value change
   */
  useEffect(() => {
    setSelectedFilter(value);
  }, [value]);

  /**
   * Event fired on filter item click
   * @param filter the filter clicked
   */
  const handleSelectFilter = (filter: TIME_PERIOD) => {
    setSelectedFilter(filter);

    onChange && onChange(filter);
  };

  return (
    <ToggleButtonGroup standaloneButtons={false} direction="row" exclusive={true} className={className}>
      {periods.map((filter: TIME_PERIOD, index: number) => (
        <ToggleButton
          key={index}
          color="secondary"
          size="small"
          value={filter}
          onClick={() => handleSelectFilter(filter)}
          selected={selectedFilter == filter}
        >
          {filter}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default TimePeriodFilters;
